/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "./core/has.js";
import { deepMerge as e } from "./core/object.js";
var s;
var r = {
  apiKey: void 0,
  applicationUrl: null == (s = globalThis.location) ? void 0 : s.href,
  assetsPath: "",
  fontsUrl: "https://static.arcgis.com/fonts",
  geometryService: null,
  geometryServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Geometry/GeometryServer",
  geoRSSServiceUrl: "https://utility.arcgis.com/sharing/rss",
  kmlServiceUrl: "https://utility.arcgis.com/sharing/kml",
  portalUrl: "https://www.arcgis.com",
  workers: {
    loaderConfig: {
      has: {},
      paths: {},
      map: {},
      packages: []
    }
  },
  request: {
    httpsDomains: ["arcgis.com", "arcgisonline.com", "esrikr.com", "premiumservices.blackbridge.com", "esripremium.accuweather.com", "gbm.digitalglobe.com", "firstlook.digitalglobe.com", "msi.digitalglobe.com"],
    interceptors: [],
    maxUrlLength: 2e3,
    proxyRules: [],
    proxyUrl: null,
    timeout: 6e4,
    trustedServers: [],
    useIdentity: !0
  },
  log: {
    interceptors: [],
    level: null
  }
};

if (globalThis.esriConfig && (e(r, globalThis.esriConfig, !0), delete r.has), !r.assetsPath) {
  var _e = "4.22.2";
  r.assetsPath = "https://js.arcgis.com/".concat(_e.slice(0, -2), "/@arcgis/core/assets");
}

r.baseUrl && console.warn("[esri.config]", "baseUrl has been replaced by assetsPath"), Object.defineProperty(r, "baseUrl", {
  set: function set() {
    console.warn("[esri.config]", "baseUrl has been replaced by assetsPath");
  }
}), r.request.corsEnabledServers = [], r.request.corsEnabledServers.push = function () {
  return console.warn("[esri.config]", "request.corsEnabledServers is not supported and will be removed in a future release. See http://esriurl.com/cors8664"), 0;
};
export { r as default };